import React from "react";
import { useAuth } from "../../contexts";

export interface WithRestaurantIdProps {
  restaurantId: string;
}

/**
 * HOC that injects restaurantId prop from AuthContext.
 * Should only be used within protected routes where restaurantId is guaranteed to exist.
 */
export function withRestaurantId<P extends WithRestaurantIdProps>(
  Component: React.ComponentType<P>
): React.FC<Omit<P, "restaurantId">> {
  const WithRestaurantIdComponent: React.FC<Omit<P, "restaurantId">> = (props) => {
    const { authState } = useAuth();
    const restaurantId = authState.currentRestaurant?.id;

    if (!restaurantId) {
      // This should never happen inside AuthenticatedLayout
      console.error("withRestaurantId: restaurantId not found in auth context");
      return null;
    }

    return <Component {...(props as P)} restaurantId={restaurantId} />;
  };

  WithRestaurantIdComponent.displayName = `withRestaurantId(${Component.displayName || Component.name || "Component"})`;

  return WithRestaurantIdComponent;
}
